module.exports = __webpack_public_path__ + "fonts/Raleway-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Raleway-Regular.ttf
// module id = 2213
// module chunks = 0